import {ISnackbarMessage} from '@components/@shared/Snackbar/MeinSnackbar';
import {BusEventEnum, EventBus} from '@core/eventBus';

export const sendSnackbarMessage = (message: ISnackbarMessage) => {
    EventBus.send<ISnackbarMessage>({
        key: BusEventEnum.SNACKBAR_MESSAGE,
        data: message,
    });
};
